import type { LocationGeocodeFormValues } from "../../../hooks/useLocationAddressGeocode";
import type { ShadowLocation } from "../../../types/location-map";

export const emptyLocationFormValues = (): LocationGeocodeFormValues => ({
	city: "",
	latitude: "",
	longitude: "",
	name: "",
	postalCode: "",
	stateProvince: "",
	street1: "",
	street2: "",
	timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
});

export const locationToFormValues = (
	location: ShadowLocation,
): LocationGeocodeFormValues => ({
	city: location.address?.city ?? "",
	latitude: location.coordinates?.coordinates[1]?.toString() ?? "",
	longitude: location.coordinates?.coordinates[0]?.toString() ?? "",
	name: location.name,
	postalCode: location.address?.postalCode ?? "",
	stateProvince: location.address?.stateProvince ?? "",
	street1: location.address?.street1 ?? "",
	street2: location.address?.street2 ?? "",
	timezone: location.timezone ?? "",
});
